// extracted by mini-css-extract-plugin
export default {"shareLink":"ShareLink_shareLink__4JPlS","shareLinkName":"ShareLink_shareLinkName__+bkMU"};